import { render } from "./actions.template.html?vue&type=template&id=5483f1c2&scoped=true"
import script from "./Actions.vue?vue&type=script&lang=ts"
export * from "./Actions.vue?vue&type=script&lang=ts"

import "./Actions.vue?vue&type=style&index=0&id=5483f1c2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5483f1c2"

export default script